import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  WebGalleryStoreProvider,
  WindowSizeContextProvider,
  LanguageContextProvider,
} from "../hooks";
import WebGalleryError from "./routes/web-gallery-error/WebGalleryError";
import WebGallery from "./routes/web-gallery/WebGallery";
import WebDetail from "./routes/web-detail/WebDetail";
import Authorize from "./routes/Authorize";
import Script from "react-load-script";

export interface IWebGalleryUrlParams {
  galleryId: string;
  assetId: string;
}

const PENDO_API_KEY = "d1d4f63b-8b9e-446f-6891-89b73de157d2";

const App = (props: { config: MediaValetConfiguration }) => {
  return (
    <WebGalleryStoreProvider config={props.config}>
      <Script
        url={`https://cdn.pendo.io/agent/static/${PENDO_API_KEY}/pendo.js`}
        onLoad={() => {
          if (!pendo) {
            console.warn("Pendo failed to load.");
            return;
          }
          pendo.initialize({
            account: { id: props.config.currentOrgUnit?.id },
            //@ts-ignore `name` not provided in typings, but existed in previous application.
            name: props.config.currentOrgUnit?.names?.name,
            dataCentre: props.config.api,
            //Prevents Pendo badge from showing up
            guides: {
              disable: true,
              delay: true,
            },
          });
        }}
      />
      <WindowSizeContextProvider>
        <LanguageContextProvider>
          <Router basename="/galleries">
            <Switch>
              <Route
                exact
                path="/:galleryId-ExternalUser/authorize"
                component={Authorize}
              />
              <Route
                exact
                path="/:galleryId-ExternalUser"
                component={WebGallery}
              />
              <Route
                exact
                path="/:galleryId-ExternalUser/:assetId/authorize"
                component={Authorize}
              />
              <Route
                exact
                path="/:galleryId-ExternalUser/:assetId"
                component={WebDetail}
              />
              <Route path="*" component={WebGalleryError} />
            </Switch>
          </Router>
        </LanguageContextProvider>
      </WindowSizeContextProvider>
    </WebGalleryStoreProvider>
  );
};

export default App;